import { gql } from '@apollo/client';
import { EVENT_PLAN_FIELDS } from '../../components/EventPlan/graphql';

export const GET_EVENT_PLANS = gql`
  query GetEventPlans {
    authenticatedGuest {
      id
      eventPlans {
        id
        ...EventPlanFields
      }
    }
  }
  ${EVENT_PLAN_FIELDS}
`;

export const CREATE_EVENT_PLAN = gql`
  mutation CreateEventPlan($input: CreateEventPlanInput!) {
    createEventPlan(input: $input) {
      eventPlan {
        id
        ...EventPlanFields
      }
    }
  }
  ${EVENT_PLAN_FIELDS}
`;

export const UPDATE_EVENT_PLAN = gql`
  mutation UpdateEventPlan($input: UpdateEventPlanInput!) {
    updateEventPlan(input: $input) {
      eventPlan {
        id
        ...EventPlanFields
      }
    }
  }
  ${EVENT_PLAN_FIELDS}
`;

export const SEND_EVENT_PLAN_INVITATION = gql`
  mutation SendEventPlanInvitation($input: SendEventPlanInvitationInput!) {
    sendEventPlanInvitation(input: $input) {
      eventPlanInvitation {
        id
        inviteeEmail
        createdAt
        eventPlan {
          id
          invitations {
            id
            inviteeEmail
            createdAt
          }
        }
      }
      errors {
        message
      }
    }
  }
`;

export const GET_EVENT_PLAN_INVITATIONS = gql`
  query GetEventPlanInvitations {
    eventPlanInvitations {
      id
      eventPlan {
        name
      }
      inviter {
        id
        fullName
        gravatarUrl
      }
      inviteeEmail
      createdAt
    }
  }
`;

export const ACCEPT_EVENT_PLAN_INVITATION = gql`
  mutation AcceptEventPlanInvitation($input: AcceptEventPlanInvitationInput!) {
    acceptEventPlanInvitation(input: $input) {
      eventPlan {
        ...EventPlanFields
      }
      errors {
        message
      }
    }
  }
  ${EVENT_PLAN_FIELDS}
`;

export const DECLINE_EVENT_PLAN_INVITATION = gql`
  mutation DeclineEventPlanInvitation(
    $input: DeclineEventPlanInvitationInput!
  ) {
    declineEventPlanInvitation(input: $input) {
      success
      errors {
        message
      }
    }
  }
`;
